import firebase from 'firebase';
import { db } from './firebase';
import { firestoreKeys } from '../utils/constants';

// ----------------------------------------------------

export default function useSupportTicketService() {
  const createSupportTicket = (data) =>
    db.collection(firestoreKeys.SUPPORT_TICKETS).add({
      ...data,
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  return { createSupportTicket };
}
